import { Flex } from '@duxton-web/ui';
import React from 'react';

const FlexColumn = ({ children }) => (
  <Flex vertical gap={16}>
    {children}
  </Flex>
);

export default FlexColumn;
